import { styled } from "styled-components";
import { device } from "../../styles/style";

export const Box = styled.div`
  width: 90px;
  height: 90px;
  background-color: var(${(props) => props.color});
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) =>
    props.color === "--lightGreen" || props.color === "--green"
      ? "var(--grey)"
      : "var(--mainBgColor)"};
  font-weight: 500;
  font-size: 0.6rem;
  text-align: center;
  cursor: pointer;
  transition: 200ms;

  &:hover {
    box-shadow: 0 0 5px var(--mainTextColor);
  }

  p {
    width: 80px;
    text-transform: uppercase;
  }

  @media ${device.mobileS} and ${device.tablet} {
    width: 30px;
    height: 30px;
    font-size: 0.2rem;

    p {
      width: 20px;
    }
  }

  @media ${device.laptop} and ${device.laptopMax} {
    width: 70px;
    height: 70px;
    font-size: 0.4rem;

    p {
      width: 60px;
    }
  }

  @media (min-width: 1025px) {
    width: 90px;
    height: 90px;
  }

  @media${device.tv} {
    width: 120px;
    height: 120px;
    font-size: 0.8rem;

    p {
      width: 110px;
    }
  }

  @media${device.tvL} {
    width: 140px;
    height: 140px;
    font-size: 1rem;

    p {
      width: 110px;
    }
  }

  @media${device.uhd} {
    width: 250px;
    height: 250px;
    font-size: 2rem;

    p {
      width: 230px;
    }
  }
`;
